import { useMediaQuery } from '@react-hook/media-query';

export const CHECKOUT_CARD_SIDE_BY_SIDE_MIN_WIDTH = 1532;

export const useCheckoutCardSideBySide = (): boolean =>
  useMediaQuery(`(min-width: ${CHECKOUT_CARD_SIDE_BY_SIDE_MIN_WIDTH}px)`);
